import { Drawer } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { RootState } from '../../app/store';
import { closeDrawer } from '../slices/drawerSlice';

const CommonDrawer = () => {
  const { title, content, width, open } = useSelector((state: RootState) => state.drawerSlice);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(closeDrawer());
    };
  }, [dispatch]);

  const handleClose = () => {
    dispatch(closeDrawer());
  };

  return (
    <Drawer
      size='default'
      title={title}
      open={open}
      footer={null}
      width={width}
      onClose={handleClose}
    >
      {content}
    </Drawer>
  );
};

export default CommonDrawer;
